import React from 'react';
import PropTypes from 'prop-types';

const Divider = ({ Style }) => <hr className={Style.dividerLine} />;

Divider.propTypes = {
  Style: PropTypes.shape({}),
};

export default React.memo(Divider);
